<div id="dashboard" style="margin-top: 3rem;" >
    <app-dashboard></app-dashboard>
</div>
<div id="dashboardStyles" #container></div>
